
import {
  ConnectionAemEnvironmentState,
  addConnectionAemEnvironmentConnection,
  connectionName as aemEnvConnectionName,
} from '@owc/connection-aem-environment';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import i18n from './i18n/index';
import { AppBase } from './AppBase';
import { logger } from './utils/logger';
import { SeamlessCoreStore } from '@seamless/store';
import FssInput from './components/fss-input/fss-input.vue';
import FssInputCategories from './components/fss-input-categories/fss-input-categories.vue';
import { VueSeamlessStore } from '@seamless/vue-store-plugin';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue, Prop } from 'vue-property-decorator';
import IApplication, { trackingService } from '../../search-library/src/services/tracking/trackingService';
import { INTEGRATION_TYPES } from './constants';
import { STAGES } from '../../search-library/src/config/environment/environment';
import { getters } from './state/store';

const application: IApplication = {
  id: 'fss',
  version: '0.1',
};

if (!window.aemNamespace) {
  Vue.use(new VueSeamlessStore());
}

@Component({
  i18n,
  components: { FssInput, FssInputCategories },
  mixins: [new VueSeamlessStore().mixin],
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default class App extends AppBase {
  store!: SeamlessCoreStore;
  private DEFAULT_SEARCH_PROFILE = '719418a2-3c7e-4690-ab88-fcac14a2f2c8';

  @Prop()
  componentId!: string;

  @Prop({ default: '' })
  appId!: string;

  @Prop({ default: INTEGRATION_TYPES.AEM })
  integrationType!: INTEGRATION_TYPES;

  get textDirection(): string {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (getters.features() as any).text_direction || 'ltr';
  }

  get component(): typeof FssInputCategories | typeof FssInput {
    logger.debug(
      '(getters.versions() as any)?.fssInputCategory ',
      (getters.versions() as any)?.fssInputCategory ? 'FssInputCategories' : 'FssInput',
    );
    return (getters.versions() as any)?.fssInputCategory ? FssInputCategories : FssInput;
  }

  created(): void {
    trackingService.setApplication(application, 'fss_search_header');
    if (this.isEnviromenteAem()) {
      addConnectionAemEnvironmentConnection().then(() => {
        this.store.subscribe(aemEnvConnectionName, this.onAemEvent);
      });
    } else {
      this.initWithSearchProfile(this.getSearchProfile(), STAGES.TEST);
      this.setSearchProfile();
    }
  }

  isEnviromenteAem(): boolean {
    return this.integrationType === INTEGRATION_TYPES.AEM;
  }

  onAemEvent(state: ConnectionAemEnvironmentState): void {
    logger.debug('onAemEvent', state);

    const { language, country, stage } = state;
    logger.debug('Running in AEM environment. Initialising the with the following config: ', state);
    trackingService.setAemEnviroment();
    logger.debug('Create elements: ', country, language);
    this.initWithMarketConfig(country, language, stage);
  }

  setSearchProfile(): void {
    const params = new URLSearchParams(window.location.search);
    params.set('sp', this.getSearchProfile());
    localStorage.setItem('fss.standalone.sp', this.getSearchProfile());

    window.history.replaceState(null, '', `?${params.toString()}`);
  }

  getSearchProfile(): string {
    const savedSearchProfile = localStorage.getItem('fss.standalone.sp');
    const params = new URLSearchParams(window.location.search);

    if (!params.get('sp')) {
      return savedSearchProfile || this.DEFAULT_SEARCH_PROFILE;
    }

    return params.get('sp') as string;
  }
}
